import React from 'react';
import GoogleMapReact, { Props } from 'google-map-react';
import { Place } from 'styled-icons/material/Place';

import { getStyledSystemProps, getCoordinatesOfAddress } from 'src/helpers';
import { BaseBox, LayoutBox, LayoutBoxProps } from 'src/kit';

export type GoogleMapProps = LayoutBoxProps &
  Props &
  ({ lat: number; lon: number } | { address: string }) & { onCoordinatesChange?: ({ lat, lng }) => void };

export const GoogleMap = ({ lat, lng, address, onCoordinatesChange, ...rest }) => {
  const [styledProps, restProps] = getStyledSystemProps(rest);
  const [coordinates, setCoordinates] = React.useState({ lat, lng });
  const geocodeAddress = React.useCallback(
    async function() {
      try {
        const {
          results: [firstResult]
        } = await getCoordinatesOfAddress(address);
        setCoordinates(firstResult.geometry.location);
        onCoordinatesChange(firstResult.geometry.location);
      } catch {}
    },
    [address, onCoordinatesChange]
  );

  const didMountRef = React.useRef(false);

  React.useEffect(() => {
    if (address) {
      if (!didMountRef.current) {
        if (!lat || !lng) {
          geocodeAddress();
        }
        didMountRef.current = true;
      } else {
        geocodeAddress();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address, geocodeAddress]);

  return (
    <LayoutBox {...styledProps}>
      <GoogleMapReact
        bootstrapURLKeys={{ key: process.env.PUBLIC_GOOGLE_MAPS_API_KEY }}
        center={coordinates}
        {...restProps}
      >
        <BaseBox as={Place} size={20} color="azure" {...coordinates} />
      </GoogleMapReact>
    </LayoutBox>
  );
};

GoogleMap.defaultProps = {
  defaultZoom: 8,
  mb: 20,
  height: 235
};

export default GoogleMap;
